import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReactiveComponent } from '@schenck/rotec-components';
import { TaskModalService, getMachineTaskModalInfos } from 'src/components';
import { MachineTaskModalService } from './machine-task-modal.service';
import { TaskModalComponent } from '../../../components/task-modal/task-modal/task-modal.component';

@Component({
  selector: 'ma-machine-task-modal',
  templateUrl: './machine-task-modal.component.html',
  providers: [
    MachineTaskModalService,
    { provide: TaskModalService, useExisting: MachineTaskModalService },
  ],
  imports: [TaskModalComponent],
})
export class MachineTaskModalComponent extends ReactiveComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly taskModalService = inject(MachineTaskModalService);
  private readonly translate = inject(TranslateService);

  constructor() {
    super();
  }

  public state = this.connect(
    getMachineTaskModalInfos(
      this.taskModalService.task$,
      this.taskModalService.machine$,
      this.taskModalService.plant$,
      this.translate
    ),
    this.cdr
  );
}
